import { z } from "zod";

export const Todo = z.discriminatedUnion("refType", [
  z.object({
    title: z.string().min(1),
    identifier: z.string().min(1),
    refId: z.string().min(1),
    refType: z.literal("newDealRequest"),
    type: z.enum(["newDealContractReview", "procurementDepositPayment"]),
  }),
  z.object({
    title: z.string().min(1),
    identifier: z.string().min(1),
    refId: z.string().min(1),
    refType: z.literal("dealExtensionRequest"),
    type: z.enum(["renewalContractReview", "renewalFeesPayment"]),
  }),
]);
